// test1606
(1606 && 0);
